import "@interopio/fdc3";
import { initializeFinsembleGlobals } from "./fsbl";
if (typeof window !== "undefined") {
    const glueFunction = window.Glue;
    if (glueFunction) {
        const fsblGlobals = initializeFinsembleGlobals(glueFunction);
        Object.keys(fsblGlobals).forEach((key) => {
            window[key] = fsblGlobals[key];
        });
        console.debug("FSBL preload loaded");
    }
}
